import styled from 'styled-components';
import { FlexColumn } from '../../../../../styled/common';

export const ContentWrapper = styled(FlexColumn)`
  gap: 15px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    gap: 20px;
  }
`;
